// src/contexts/ThemeContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}

export function ThemeProvider({ children }) {
  // Initialize theme from localStorage or default to 'dark'
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme || 'dark';
  });

  // Update theme and save to localStorage
  const toggleTheme = () => {
    setTheme(prevTheme => {
      const themeOrder = ['light', 'dark', 'ocean'];
      const currentIndex = themeOrder.indexOf(prevTheme);
      const nextIndex = (currentIndex + 1) % themeOrder.length;
      const newTheme = themeOrder[nextIndex];
      localStorage.setItem('theme', newTheme);
      return newTheme;
    });
  };

  const setThemeMode = (mode) => {
    if (mode === 'light' || mode === 'dark' || mode === 'ocean') {
      setTheme(mode);
      localStorage.setItem('theme', mode);
    }
  };

  // Apply theme to document root
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  const value = {
    theme,
    toggleTheme,
    setThemeMode,
    isDarkMode: theme === 'dark',
    isLightMode: theme === 'light',
    isOceanMode: theme === 'ocean',
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
}


